import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { FetchBaseQueryError, FetchBaseQueryMeta, createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import * as store from '../store';
import { connVsContract, StatsReport } from '../stats/types/stats'


const initialConnVsContractState: connVsContract[] = [];

export const statsSlice = createSlice({
    name: 'Stats',
    initialState: initialConnVsContractState,
    reducers: {
        getStats: (state, lastStats: PayloadAction<connVsContract[]>) => {
            Object.assign(state, lastStats.payload);
        }
    }
});

export const statsApi = createApi({
    reducerPath: 'StatsApi',
    tagTypes: ['Stats'], // used to refresh => see Invalidate tags
    // SEE ALSO : https://redux-toolkit.js.org/rtk-query/api/createApi#onquerystarted
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.PUBLIC_URL}/api/Stats/`,
        prepareHeaders: (headers, { getState }) => {
            const accessToken = (getState() as store.RootState).userStateReducer.accessToken;

            if (accessToken !== '') {
                headers.set('authorization', `Bearer ${accessToken}`)
            }

            return headers
        },
    }),
    endpoints: (build) => ({
        getStats: build.query<StatsReport, string>({
            query: (statType: string) => `GetStats?stattype=${statType}`,
            providesTags: ['Stats'],
            transformErrorResponse: (failure: FetchBaseQueryError, meta: FetchBaseQueryMeta) => {
                let returnedError: string = 'An error occured while requesting statistics';
                switch (failure.status) {
                    case "FETCH_ERROR":

                        break;
                    case "PARSING_ERROR":

                        break;
                    case "TIMEOUT_ERROR":

                        break;
                    case "CUSTOM_ERROR":

                        break;
                }
                returnedError = `${failure.status}  - ${returnedError}`;
                return returnedError;
            }
        })
    })  
})

export const statsReducer = statsSlice.reducer;
export const { getStats } = statsSlice.actions;


/* 
    ALERT VERY ANNOYING RTQK : React hook below is not generated when using :
    import { FetchBaseQueryError, FetchBaseQueryMeta, createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query";

    IT MUST BE 
    import { FetchBaseQueryError, FetchBaseQueryMeta, createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";

    https://stackoverflow.com/questions/69502501/redux-rtk-not-auto-generating-react-hooks
*/

export const { useGetStatsQuery } = statsApi;